// This file is used in deployment (Jenkins) for adding the build timestamp to the version number
// DO NOT MODIFY
export const BUILD_TIMESTAMP = 'local';
